import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

const Acesso = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    const handleAutoLogin = async () => {
      const email = searchParams.get('email');

      if (!email) {
        navigate('/login');
        return;
      }

      try {
        const result = await signIn(email);

        if (result.error) {
          throw result.error;
        }

        toast({
          title: "¡Bienvenido!",
          description: "Acceso validado correctamente.",
        });

        navigate('/app');
      } catch (err: any) {
        console.error("Auto-login error:", err);
        toast({
          title: "Error de acceso",
          description: "No pudimos validar tu acceso automáticamente. Por favor, ingresa manualmente.",
          variant: "destructive",
        });
        navigate('/login');
      }
    };

    handleAutoLogin();
  }, [searchParams, signIn, navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="text-muted-foreground animate-pulse">Preparando tu acceso...</p>
      </div>
    </div>
  );
};

export default Acesso;
